// Attaches a `latestAllocation` map to each forecast (keyed by SKU)
// where each value is max(maxLevel - currentSOH, 0).
// `ledger` is a flat map of { [sku]: currentSOH } from mainApi.ledger.getOne
const computeQto = (forecasts, ledger = {}) =>
  forecasts.map(forecast => ({
    ...forecast,
    latestAllocation: Object.keys(forecast.maxLevel).reduce((acc, sku) => {
      acc[sku] = Math.max((forecast.maxLevel[sku] || 0) - (ledger[sku] || 0), 0)
      return acc
    }, {})
  }))

module.exports = computeQto
